import { createContext } from 'react';

export interface ToastOptions {
  message: string;
  actionLabel?: string;
  onAction?: () => void;
  /** Auto-dismiss delay in ms. Defaults to 3000. */
  durationMs?: number;
  /**
   * `top` (default) sits under the status bar. `bottom` sits above the game
   * ActionBar, for screens whose top bar must stay uncovered.
   */
  placement?: 'top' | 'bottom';
}

export interface ToastApi {
  /** Shows a toast (replacing any visible one) and returns its id. */
  showToast(options: ToastOptions): number;
  dismissToast(id?: number): void;
}

export const DEFAULT_TOAST_DURATION_MS = 3000;

/** Without a provider the API is a no-op so isolated components still render. */
export const ToastContext = createContext<ToastApi>({
  showToast: () => 0,
  dismissToast: () => undefined,
});
